var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center text-sm"},_vm._l((_vm.steps),function(step,index){return _c('BreadcrumbLink',{key:index,attrs:{"to":step.path,"active":index === _vm.steps.length - 1}},[_vm._v(_vm._s(step.label))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }